import styled from "styled-components";

import { Text } from "@ui/Atoms";

export const Root = styled(Text).attrs({
  $style: "regular_14",
  $color: "grey400",
})``;
